










































































































































import {
  getIntegralGoodsListData,
  getIntegralGoodsListApi,
  setIntegralGoodsStatusApi,
  deleteIntegralGoodsApi,
} from "@/api/integral";
import sortEditor from "./sortEditor.vue";
import previewDialog from "./previewDialog.vue";
import stockDialog from "./stockDialog.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
@Component({
  name: "integralGoods",
  components: {
    sortEditor,
    previewDialog,
    stockDialog,
  },
})
export default class extends Vue {
  searchInfo: any = {
    status: -1,
  };
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    this.handleSearch();
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleRefresh(type?: string) {
    let page = this.page;
    if (
      type === "delete" &&
      (this.page - 1) * this.pageSize + 1 === this.total
    ) {
      page = page - 1;
    }
    this.getList({
      page: page > 0 ? page : 1,
      page_size: this.pageSize,
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: getIntegralGoodsListData = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.status >= 0) {
      option.status = this.searchInfo.status;
    }
    if (this.searchInfo.goods_name) {
      option.goods_name = this.searchInfo.goods_name;
    }
    getIntegralGoodsListApi(option).then((res: any) => {
      res.data.list.map((item: any) => {
        item.status = item.status === 1;
      });
      this.page = res.data.page;
      this.total = res.data.total;
      this.tableData = res.data.list;
    });
  }
  toDetail(id: number) {
    this.$router.push({
      name: "integralGoodsDetail",
      query: {
        id: String(id),
      },
    });
  }
  handleDelete(row: any) {
    this.$confirm(
      "删除后，用户无法再兑换，旧兑换信息需要手动取消。确定要删除商品？",
      `删除 - ${row.goods_name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        deleteIntegralGoodsApi({ goods_id: row.goods_id }).then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.handleRefresh("delete");
        });
      })
      .catch(() => {});
  }
  handleSetStatus(row: any) {
    setIntegralGoodsStatusApi({
      goods_id: row.goods_id,
      status: row.status ? 1 : 2,
    })
      .then(() => {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
        this.handleRefresh();
      })
      .catch(() => {
        this.handleRefresh();
      });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  @Watch("$route")
  routeWatch() {
    this.handleSearch();
  }
}
